import React from 'react';
import PropTypes from 'prop-types';
import {Box, Heading, Paper, Text} from '@tenancy.nz/ui';

function ListingPartnerCard({
  name,
  tagline = undefined,
  logo = undefined,
  href,
  cta,
  ctaColor = '#000222',
}) {
  return (
    <Paper overflow={false} sx={{height: '100%'}}>
      <Box
        sx={{
          height: 96,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderBottom: '1px solid',
          borderColor: 'grey.300',
        }}>
        {logo ? (
          <Box
            component="img"
            src={logo}
            alt={name}
            sx={{
              maxHeight: 32,
              maxWidth: 180,
              width: 'auto',
              height: 'auto',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        ) : (
          <Heading as="h4" align="center">
            {name}
          </Heading>
        )}
      </Box>
      <Box sx={{p: 4, display: 'flex', flexDirection: 'column', gap: 4}}>
        <Box>
          <Heading as="h3">{name}</Heading>
          {tagline && (
            <Text sx={{fontSize: 16, letterSpacing: '0.48px', m: 0}}>
              {tagline}
            </Text>
          )}
        </Box>
        <Box
          component="a"
          href={href}
          target="_blank"
          rel="noreferrer"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 48,
            px: 3,
            borderRadius: '4px',
            bgcolor: ctaColor,
            color: 'common.white',
            textDecoration: 'none',
            fontWeight: 700,
            fontSize: 16,
            lineHeight: '18px',
            transition: 'filter 0.15s ease-out',
            '&:hover': {color: 'common.white', filter: 'brightness(0.9)'},
          }}>
          {cta}
        </Box>
      </Box>
    </Paper>
  );
}

ListingPartnerCard.propTypes = {
  name: PropTypes.string.isRequired,
  tagline: PropTypes.string,
  logo: PropTypes.string,
  href: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
  ctaColor: PropTypes.string,
};

export default ListingPartnerCard;
